import React, { createRef, useEffect, useState } from "react";
// import { mobile, tablet } from "../../data/bp";
// import { decodeStyle, parseStyle } from "../../parser/parserResponsive";
import { decodeStyle, parseStyle, mobile, tablet } from "../../../../juntion";
import axios from "axios";
import log from "cslog";

const FORM_SUBMIT_URL = "https://api.qureal.com/items/qform_contact";

function ContactForm({ id, db, device, gs, ctx }) {
    const formRef = createRef();
    const [status, setStatus] = useState("idle");
    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        contact_no: "",
        company_name: "",
        requirement: "",
        // website: null,
        // emailTo: null
    });
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    log.d(ctx, "CTX ContactForm");

    const submitForm = (eve) => {
        eve.preventDefault();
        const out = {
            ...formData,
            emailTo: input.emailTo,
            website: ctx?.creation,
        };
        // log.d(out, "FormData");
        // return;
        setStatus("loading");
        axios
            .post(FORM_SUBMIT_URL, {
                ...out,
            })
            .then((res) => {
                if (res.status > 200 && res.status < 300) {
                    setStatus("success");
                }
            })
            .catch((res) => {
                setStatus("error");
            })
            .then(() => {});
    };

    return (
        <div
            style={{
                height: "100%",
                width: "auto",
                alignSelf: input.alignImage,
                ...decodeStyle(ps.style, gs),
                backgroundColor: input.backgroundColor,
            }}
        >
            <form
                ref={formRef}
                className="qform"
                onSubmit={submitForm}
                name="EmailForm"
                style={{
                    position: "relative",
                }}
            >
                <label>Full Name</label>
                <input
                    type="text"
                    id="fullName"
                    placeholder="Full Name"
                    required={true}
                    value={formData.full_name}
                    onChange={(eve) =>
                        setFormData({
                            ...formData,
                            full_name: eve.target.value,
                        })
                    }
                />

                <label>Company Name</label>
                <input
                    type="text"
                    id="companyName"
                    placeholder="Company Name"
                    required={true}
                    value={formData.company_name}
                    onChange={(eve) =>
                        setFormData({
                            ...formData,
                            company_name: eve.target.value,
                        })
                    }
                />

                <label>Contact No</label>
                <input
                    type="number"
                    id="contactNo"
                    placeholder="Your Contact No."
                    required={true}
                    value={formData.contact_no}
                    onChange={(eve) =>
                        setFormData({
                            ...formData,
                            contact_no: eve.target.value,
                        })
                    }
                />

                <label>Email </label>
                <input
                    type="email"
                    id="email"
                    placeholder="Your Email"
                    required={true}
                    value={formData.email}
                    onChange={(eve) =>
                        setFormData({
                            ...formData,
                            email: eve.target.value,
                        })
                    }
                />

                <label>Requirement</label>
                <textarea
                    id="requirement"
                    name="requirement"
                    rows={4}
                    required={true}
                    value={formData.requirement}
                    onChange={(eve) =>
                        setFormData({
                            ...formData,
                            requirement: eve.target.value,
                        })
                    }
                />
                <button type="submit">Submit</button>
                {["loading", "success"].includes(status) && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#C8F5F7",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {status === "loading" && <h3>Submitting enquiry...</h3>}
                        {status === "success" && (
                            <p>
                                {input.successMessage ||
                                    "Thanks for enquiry. We will contact you soon"}
                            </p>
                        )}
                    </div>
                )}
            </form>
        </div>
    );
}

export default ContactForm;
